function initCopySelectEvent(container) {
  container.querySelectorAll('.js-nearby-facility').forEach((facility) => {
    App.components.selection_tracking(
      facility.childNodes[0],
      (event) => {
        App.track.event('venue_page_interaction', {
          section: 'nearby_facilities',
          element: 'facility',
          element_value: facility.dataset.category,
          interaction: event.type === 'copy' ? 'copy' : 'select',
        });
      },
      500,
    );
  });
}

function initTabs(container) {
  const tabsContainer = document.querySelector('.js-venuepage-nearby-tabs');
  const navigationTabs = tabsContainer.querySelectorAll('.ds-tab-item');
  const tabsContent = container.querySelectorAll('[data-nearby-section]');

  function switchTab(navigationTabElement) {
    if (!navigationTabElement) {
      return;
    }
    tabsContent.forEach((tabContent) => {
      tabContent.classList.add('hidden');
    });
    navigationTabs.forEach((tab) => {
      tab.classList.remove('ds-tab-item--active');
    });

    const section = navigationTabElement.dataset.section;
    navigationTabElement.classList.add('ds-tab-item--active');
    container.querySelector(`[data-nearby-section="${section}"]`).classList.remove('hidden');
  }

  tabsContainer.querySelectorAll('.ds-tab-item').forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      App.track.event('venue_page_interaction', {
        section: 'nearby_facilities',
        element: 'category_tab',
        element_value: e.target.dataset.section,
        interaction: 'click',
      });

      switchTab(e.target);
    });
  });
  if (window.matchMedia('(max-width: 767.98px)').matches) {
    switchTab(navigationTabs[0]);
  }
}

export const initNearbyExperiment = () => {
  const container = document.querySelector('.p-venuepage-nearby');
  if (!container) return;

  initCopySelectEvent(container);
  initTabs(container);
};
